import { Line } from "rc-progress";
import React from "react";
import { Trans, useTranslation } from "react-i18next";

const ScansDataHeader = ({
    selectedRows,
    data,
    setIncludeReferencesModelVisible,
    // setIsReferenceModalOpen,
    // isReferenceModalOpen,
    dataReferenceFileName,
    referenceProgressBarValue,
}) => {
    const { t } = useTranslation();

    return (
        <>
            <header className="main-content-header flex items-center justify-between">
                <h3 className="h3">{t("scansData")}</h3>
                <div className="action-header-wrapper flex items-center">
                    <button
                        className="secondary-green-btn"
                        onClick={() => setIncludeReferencesModelVisible(true)}
                        disabled={data == null || selectedRows.length == 0}
                    >
                        <i className="far fa-bookmark" />
                        <span className="ml-2">
                            <Trans i18nKey="markAsMeasurements">
                                Mark as Measurements
                            </Trans>
                        </span>
                    </button>
                    {/* <button
                        className="secondary-green-btn ml-2"
                        onClick={() =>
                            setIsReferenceModalOpen(!isReferenceModalOpen)
                        }
                        disabled={data == null}
                    >
                        <i className="fas fa-file-upload" />
                        <span className="ml-2">
                            <Trans i18nKey="uploadReferences">
                                Upload References
                            </Trans>
                        </span>
                    </button> */}
                </div>
            </header>
            <div className="title-with-desc-section">
                {/* REFERENCE PROGRESS BAR */}
                {dataReferenceFileName && (
                    <div className="relative pt-1">
                        <div className="flex mb-2 items-center justify-between">
                            <div>
                                <span className="text-xs font-semibold inline-block py-1 px-2">
                                    {referenceProgressBarValue !== 100 ? (
                                        <span className="uppercase text-primary-blue">
                                            Uploading Reference in progress...
                                        </span>
                                    ) : (
                                        <>
                                            <span className="uppercase text-primary-blue">
                                                Reference Uploaded:
                                            </span>
                                            <span className="mx-2 font-medium blue-color">
                                                {dataReferenceFileName}
                                            </span>
                                        </>
                                    )}
                                </span>
                            </div>
                            <div className="text-right">
                                <span className="text-xs font-semibold inline-block text-primary-blue">
                                    {referenceProgressBarValue}%
                                </span>
                            </div>
                        </div>
                        <Line
                            percent={referenceProgressBarValue}
                            strokeWidth="1"
                            strokeColor="#4ac990"
                        />
                    </div>
                )}
            </div>
        </>
    );
};

export default ScansDataHeader;
